import { useSettingsStore } from '~/stores/settings'
import { pageUrl } from '~/helpers/urls'

const settings = useSettingsStore()

export const useServicesStore = defineStore('services', {
  state: () => ({
    title: '',
    subtitle: '',
    footer_data: {},
    content: [],
    meta: {
      title: '',
      description: ''
    },
    og: {},
  }),
  actions: {
    async setIndexPage() {
      if (settings?.lang_id) {
        const params = {
          type: 'service.ServiceListPage',
          fields: '*',
          descendant_of: settings.lang_id,
        }
        try {
          const res = await useApiFetch(pageUrl, { params })
          const data = res.items[0]
          this.setPageData(data)
        } catch (err) {
          return err
        }
      }
    },
    async setSlugPage(page_slug) {
      if (settings?.lang_id) {
        const params = {
          type: 'service.ServicePage',
          fields: '*',
          descendant_of: settings.lang_id,
          slug: page_slug,
        }
        try {
          const res = await useApiFetch(pageUrl, { params })
          const data = res.items[0]
          this.setPageData(data)
        } catch (err) {
          return err
        }
      }
    },
    setPageData(data) {
        this.title = data.title
        this.content = data.content
        this.footer_data = data.content[data.content.length - 1].type === 'form' ? data.content[data.content.length - 1].value : {}
        this.meta = {
          title: data.meta.seo_title || data.title,
          description: data.meta.search_description,
        }
        this.og = data.og
    },
  }
})
